import { useSelector } from "react-redux";
import { useMemo } from "react";


// TODO: Update the filtering logic below to match the requirements for the recommended section
// once the recommended section is integrated (Sprint 9).
export default function useGetRecommendTourneyDefinitionIds() {
  const data = useSelector((state) => state?.lobby?.masterTourneysData);

  return useMemo(() => {
    if (!data || typeof data.entries !== "function") return [];
    return Array.from(data.entries())
      .filter(([tourneyId, tourney]) => tourney?.tourneyIdentifier === "myRecommend")
      .map(([key]) => key);
  }, [data]);
}
